import { motion } from "framer-motion";
import { STATS } from "../lib/data";

export const Stats = () => (
  <section data-testid="stats-section" className="border-b border-black bg-[#EAEAEA]">
    <div className="grid grid-cols-2 lg:grid-cols-4 border-l border-black">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.08 }}
          className="border-r border-b lg:border-b-0 border-black p-6 sm:p-8 md:p-12 py-12 md:py-20"
          data-testid={`stat-item-${i}`}
        >
          <span className="block w-10 h-1.5 mb-5" style={{ background: s.color }} />
          <div className="font-display font-bold text-4xl sm:text-5xl md:text-7xl tracking-tighter leading-none mb-4">
            {s.value}
          </div>
          <div className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-black/60">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
